const SEC = 1000
const MIN = 60 * SEC
const TRACKER_LOG_INTERVAL = 3 * MIN
export default TRACKER_LOG_INTERVAL
